import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";


type State = {
    informacaoFaturamentos: PaginationProperties,
    enderecos: PaginationProperties,
    centroCustoEnderecos: PaginationProperties,

}

type Action = {
    informacaoFaturamentosSetter: SetPaginationProperties,
    enderecosSetter: SetPaginationProperties,
    centroCustoEnderecosSetter: SetPaginationProperties,

}

export const usePagination = create<State & Action>((set) => ({
    informacaoFaturamentos: InitializePaginationProperties({ rowsPerPage: 5 }),
    informacaoFaturamentosSetter: InitializeSetPaginationProperties(set, 'informacaoFaturamentos'),

    enderecos: InitializePaginationProperties({ rowsPerPage: 5 }),
    enderecosSetter: InitializeSetPaginationProperties(set, 'enderecos'),

    centroCustoEnderecos: InitializePaginationProperties({ rowsPerPage: 5 }),
    centroCustoEnderecosSetter: InitializeSetPaginationProperties(set, 'centroCustoEnderecos'),

}));